/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { DelLegalEntityVO } from './del-legal-entity-vo.model';

export class DelBusinessProfileVoModel extends JSONable {

  uuid: string | undefined = undefined;
  businessProfileType: string | undefined = undefined;
  ownerLe: DelLegalEntityVO | undefined = undefined;
  partner: DelLegalEntityVO | undefined = undefined;
  companyName: string | undefined = undefined;

}
